import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const START_SECONDS = 17 * 60 + 34;
interface CountdownTimerProps {
  tone?: 'light' | 'dark';
}
export function CountdownTimer({
  tone = 'light'
}: CountdownTimerProps) {
  const {
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const isDark = tone === 'dark';
  return <div className={`flex flex-col items-center gap-2 rounded-2xl border px-4 py-3 ${isDark ? 'border-white/15 bg-white/5' : 'border-bad/20 bg-bad/5'}`} role="timer" aria-live="off" data-id="element-19" data-mp="1kax1olf7vhem">
      <p className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] ${isDark ? 'text-white/70' : 'text-bad'}`} data-id="element-20" data-mp="1ac7jerjeruxu">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-21" data-mp="34qrxumh4yu8s" />
        Esta oferta expira en
      </p>
      <div className="flex items-end gap-1.5" aria-label={`${minutes} minutos ${seconds} segundos`} data-id="element-22" data-mp="2zrnp1wy4iyiz">
        <TimeBox value={minutes} unit="MIN" isDark={isDark} data-id="element-23" data-mp="1c0yfe4mz3swf" />
        <span className={`pb-4 text-xl font-black ${isDark ? 'text-white/50' : 'text-bad/50'}`} data-id="element-24" data-mp="1bzdjaal0g1wg">:</span>
        <TimeBox value={seconds} unit="SEG" isDark={isDark} data-id="element-25" data-mp="1h12uprc5ahl2" />
      </div>
    </div>;
}
function TimeBox({
  value,
  unit,
  isDark
}: {
  value: string;
  unit: string;
  isDark: boolean;
}) {
  return <div className="flex flex-col items-center" data-id="element-26" data-mp="171u8jkniu799">
      <span className={`min-w-[3.25rem] rounded-xl px-2 py-1.5 text-center font-sans text-3xl font-black tabular-nums ${isDark ? 'bg-white text-navy' : 'bg-navy text-white'}`} data-id="element-27" data-mp="1uqmwattzp8ss">
        {value}
      </span>
      <span className={`mt-1 text-[9px] font-bold uppercase tracking-[0.16em] ${isDark ? 'text-white/60' : 'text-navy/50'}`} data-id="element-28" data-mp="1l0ttoibts40o">
        {unit}
      </span>
    </div>;
}